<template>
  <v-container v-show="$auth.ready()">
    <h2>Banner</h2>
    <br>
    <v-text-field :label="infoBanner.description" v-model="infoBanner.text" counter="255" hint="Enter banner message" :rules="infoBannerRules"></v-text-field>
    <br>
    <v-btn block @click="saveSettings">Save</v-btn>
  </v-container>
</template>

<script>

import {eSailServerAuth, eSailServerPublic} from "@/plugins/axios";

export default {

  name: "Settings",
  data: () => ({
    infoBanner: {
      description: "",
      text: ""
    },
    infoBannerRules: [v => v.length <= 255 || 'Max 255 characters']
  }),
  mounted() {
    eSailServerPublic.get('info/environment/variables/info_banner')
        .then(response => (
            this.infoBanner = response.data
        ))
  },
  methods: {
    saveSettings() {
      eSailServerAuth.put('admin/environment/variables', this.infoBanner,  { headers: { Authorization: `Bearer ` + this.$auth.token() }})
    }
  }
}
</script>

<style scoped>

</style>